<div *ngIf="tools.activeApp">
  <router-outlet></router-outlet>
</div>
